// Generated by purs version 0.15.16
var popstate = "popstate";
export {
    popstate
};
//# sourceMappingURL=index.js.map
